import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { db } from "../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

export default function PublicProfile() {
  const { username } = useParams(); // Holt den Namen aus der URL
  const navigate = useNavigate();
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      try {
        const q = query(collection(db, "users"), where("displayName", "==", username));
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
          // Wir nehmen den ersten Treffer
          setProfileData(querySnapshot.docs[0].data());
        } else {
          setError("User not found.");
        }
      } catch (err) {
        console.error(err);
        setError("Error loading profile.");
      }
      setLoading(false);
    };

    fetchProfile();
  }, [username]);

  if (loading) return <div style={centerStyle}><h2>Loading Profile...</h2></div>;
  if (error) return <div style={centerStyle}><h2>{error}</h2><button onClick={() => navigate(-1)}>Go Back</button></div>;

  return (
    <div style={containerStyle}>
      <Helmet><title>{username} | UN-LOCKED</title></Helmet>

      <div style={cardStyle}>
        <div style={avatarStyle}>{profileData?.avatar || "👤"}</div>
        <h1 style={{ color: "gold", margin: "10px 0" }}>{profileData?.displayName}</h1>
        <p style={{ color: "#aaa", fontStyle: "italic", marginBottom: "30px" }}>"{profileData?.bio || "Ready to play!"}"</p>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
          <div style={statBoxStyle}><div style={statTitleStyle}>Games Played</div><div style={statValueStyle}>{profileData.gamesPlayed || 0}</div></div>
          <div style={statBoxStyle}><div style={statTitleStyle}>Rounds Won 🏆</div><div style={statValueStyle}>{profileData.wins || 0}</div></div>
          <div style={statBoxStyle}><div style={statTitleStyle}>Total Gold 💰</div><div style={statValueStyle}>{profileData.totalGold || 0}</div></div>
          <div style={statBoxStyle}><div style={statTitleStyle}>Cards Discovered 🃏</div><div style={statValueStyle}>{profileData.discoveredCards?.length || 0} / 50</div></div>
        </div>

        <button onClick={() => navigate(-1)} style={{ marginTop: "30px", padding: "10px 20px", background: "#555", color: "white", border: "none", borderRadius: "8px", cursor: "pointer" }}>
          ⬅️ Back
        </button>
      </div>
    </div>
  );
}

// Styling (ähnlich wie deine Account.jsx)
const centerStyle = { color: "white", minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", backgroundColor: "#111" };
const containerStyle = { padding: "80px 20px", color: "white", minHeight: "100vh", display: "flex", justifyContent: "center", backgroundImage: "url('/background.png')", backgroundSize: "cover" };
const cardStyle = { backgroundColor: "rgba(30, 30, 30, 0.9)", border: "2px solid gold", borderRadius: 20, padding: "40px", width: "100%", maxWidth: "500px", textAlign: "center", height: "fit-content" };
const avatarStyle = { fontSize: "5em", margin: "0 auto", background: "rgba(0,0,0,0.5)", width: "120px", height: "120px", borderRadius: "50%", display: "flex", justifyContent: "center", alignItems: "center", border: "3px solid gold" };
const statBoxStyle = { backgroundColor: "rgba(0, 0, 0, 0.6)", border: "1px solid #555", borderRadius: "10px", padding: "15px" };
const statTitleStyle = { color: "#aaa", fontSize: "0.8em", textTransform: "uppercase", fontWeight: "bold" };
const statValueStyle = { color: "gold", fontSize: "1.5em", fontWeight: "bold" };